export default __webpack_public_path__ + "assets/models/4bcb8b82f815c3674eabe2e191c60dda.glb";